import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import '@/styles/index.scss'; 
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/lib/locale/lang/zh-cn'
import { createI18n } from 'vue-i18n'
import {messages} from '@/utils/js/locales.js'

const i18n = createI18n({
    locale: 'zh', // 当前语言
    messages,
    legacy: false,
    // 如果需要指定其他选项，可以设置其他选项
    // ...
})
createApp(App).use(ElementPlus,{locale:zhCn}).use(i18n).use(store).use(router).mount('#app')
